module.exports = __webpack_public_path__ + "static/media/wish_XI_cs.89a8d7e9.png";